import { AbstractControl, ValidationErrors } from '@angular/forms';

export function MockTestDescriptionValidator(
	control: AbstractControl
): ValidationErrors | null {

	const value = control.value?.trim() || '';

	if (!value) return null;

	if (value.length >= 500) {
		return {
			maxLength: true
		};
	}

	return null;
}